import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from ".././axios-interceptor";
import { base_url, LOAN_CURRENCY_TYPE_BHD, STATUS_PROCESSED } from "./../utilities";
import {
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
} from "./../utilities";
import moment from 'moment'
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import ModalFooter from './ModalFooter';
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import Cookies from 'js-cookie';

const ExtendTenureDate = (props) => {
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Business")) {
      navigate("/");
    }
  }, []);
  const [download, setDownload] = useState([]);
  const [loandata, setLoanData] = useState([]);
  const [loanrefnum, setLoanRefNum] = useState([]);
  const [datevalue, setDatevalue] = useState();
  const [servicetype, setServiceType] = useState([]);




  useEffect(() => {
    axios
      .post(base_url + "service-type-master/get_service_type")
      .then((res) => {
        setServiceType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(base_url + "loan-trx/get_loan_trx_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        const data = res.data.data;
        if (data) {
          setLoanData(data);
        } else {
          setLoanData("No Data Found");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(base_url + "documents-type/get_document_types", {})
      .then((res) => {
        let doctypes = res.data.data;
        let x = [];
        doctypes.SERVICE_REQUESTS.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
        setDownload(x);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = () => {
    const fd = new FormData();
    fd.append('loan_documents', [])
    fd.append('service_type_code', servicecode)
    fd.append('business_id', selectedobjData?.business_id)
    fd.append('user_id', selectedobjData?.user_id)
    fd.append('loan_id', selectedobjData?.loan_id)
    fd.append('loan_type_id', selectedobjData?.loan_type_id)
    fd.append('loan_purpose', selectedobjData?.loan_purpose)
    fd.append('loan_amount', selectedobjData?.loan_amount)
    fd.append('loan_currency', selectedobjData?.admin_request_loan_currency)
    fd.append('loan_tenure', selectedobjData?.loan_tenure)
    fd.append('monthly_profit_rate', "" + selectedobjData?.bennefin_roi)
    fd.append('principal_frequency', "" + selectedobjData?.principal_frequency)
    fd.append('loan_reference_number', selectedobjData?.loan_reference_number)
    fd.append('extend_tenure', datevalue)
    fd.append('created_by', Cookies.get("user_name"))
    fd.append('notes', textarea)
    documents_lst.forEach(elem => {
      if( elem.document_url){
      const fileName = elem.document_url.name;
      const lastDotIndex = fileName.lastIndexOf('.');
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fd.append('file', elem.document_url, elem.document_type+"."+fileExtension);
      }
    })
    if ( servicecode == null || selectedobjData?.loan_reference_number == null) {
      toast.error("Please select all mandatory fields", {
        toastId: 8,
      });
    }
  
     else if (datevalue == null || datevalue == "") {
        toast.error("Please select extend tenure", {
          toastId: 10,
        });
      }
     else { 
        setIsLoading(true)
        axios
          .post(
            base_url + "service-request-trx/save_new_service_request_trx",
            fd
          )
          .then((res) => {
            if (res.data.message == "Already raised extend tenure") {
              toast.error("A request for extend tenure has already been raised", {
                toastId: 4
              })
            }
            else if (res.data.message == "Already raised pre-closure") {
              toast.error("A request for pre-closure has already been raised", {
                toastId: 4
              })
            }
            else {
              props.onHide();
              toast.success("Service request created successfully", {
                toastId: 4
              })
              setTimeout(() => {
                window.location.reload();
              }, 800);;
            }
          })
          .catch((err) => {
            console.log(err);
          });


  };
}

  let serviceTypeName = [];

  {
    servicetype.map((s_type, index) => {
      if (s_type.service_type_code !== null && s_type.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
        serviceTypeName.push(s_type.service_type_name);
      }
    });
  }

  const [textarea, setTextarea] = useState("");
  const [servicecode, setServiceCode] = useState(SERVICE_REQUEST_EXTEND_TENURE);
  const handleSeriveType = (e) => {
    let value = e.target.value;
    if (value == SERVICE_REQUEST_EXTEND_TENURE) {
      setServiceCode(SERVICE_REQUEST_EXTEND_TENURE);

    }
    if (value == SERVICE_REQUEST_PRE_CLOSURE) {

      setServiceCode(SERVICE_REQUEST_PRE_CLOSURE);

    }
    if (value == 'Select') {


    }
  };

  const handleChangeInput = (e) => {
    if (e.target.name == "loanrefno") {
      setLoanRefNum(e.target.value);
    }
    if (e.target.name == "textarea") {
      setTextarea(e.target.value);
    }
    if (e.target.name == "date") {
      setDatevalue(e.target.value.split(" ")[0]);
    }
    if (e.target.value == "Select") {
      setLoanRefNum([])
      setTextarea('')
      setDatevalue([])

    }
  };

  let documents_lst = [];
  download.map((eachDoc) => {
    if (eachDoc.document_type !== undefined || eachDoc.document_type !== null)
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
      });
  });

  let filteredLoanRef = [];
  var indivloandata = [];
  {
    loandata.map((ldata) => {
      if (ldata.status == STATUS_PROCESSED) {
        if (window.location.pathname == '/myloans' && props.loanrefnum == ldata.loan_reference_number) {
          indivloandata.push(ldata)
        }
      }
      if (loanrefnum == ldata.loan_reference_number) {
        if (loanrefnum != undefined) {
          filteredLoanRef.push(ldata);
        } else {
          filteredLoanRef.push("-");
        }
      }
    });
  }

  let selectedobjData = indivloandata[0];
  const handleChange = (event, item) => {
    if (event.target.files[0].size < 5242880) {
      let sample_download = [...download];
      sample_download.forEach((doc) => {
        if (doc.doc_type == item.doc_type) {
          item.is_upload = true;
          doc.is_upload = true;
          doc.document_type = item.doc_type;
          doc.document_url = event.target.files[0];
          doc.file_name = event.target.files[0].name;
        }
      });
      setDownload(sample_download);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  }

  let months = [];
  for (let i = 1; i <= 3; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }
  const handleClose = () => {
    setLoanRefNum([])
    months.push()
    props.onHide();
    setDatevalue(null);
    download.forEach((doc) => {
      doc.is_upload = false;
      delete doc.document_type;
      delete doc.document_url;
      delete doc.file_name;
    });
  };
  let formattedNumber = '';
  if (props.loanrefnum != '') {
    const number = Number(indivloandata[0]?.loan_amount);
    formattedNumber = number != undefined ? number.toLocaleString() : '';
  }
  const handleChangeDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(file.document_url);
    window.open(fileUrl, '_blank');
    
    const url = URL.createObjectURL(file.document_url);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.document_url.name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header onHide={handleClose} closeButton>
        <Modal.Title id="contained-modal-title-vcenter p-1">
          <h6 className="mb-0">New Service Request</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal_body px-3">
      <div className={ isLoading ?"onClickApplyLoaderStyl" :'d-none'}>
        <div>
          <ThreeDots
          height="90"
          width="90"
          radius="9"
          color="#3d79f3"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={isLoading}
              />
        </div><br/>
      </div>
         { isLoading ? <div className="loader_style">Saving...</div>:''}
        <div className="col-md-2 ">
          <label htmlFor="servicename">
            <p>
              Service type <span style={{ color: "red" }}>*</span>
            </p>
          </label>
          <select
            id="servicename"
            className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
            aria-label="form-select example"
            name="servicename"
            autoComplete="off"
            onChange={handleSeriveType}>
            {servicetype.map((s_type, index) => {
              if (s_type.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
                return (

                  <option
                    value={s_type.service_type_code}
                    key={s_type.service_type_code}
                  >
                    {s_type.service_type_name}
                  </option>

                );
              }

            })}
          </select>
        </div>

        <div className=''>
          <div className="">
            <h6 className="mb-0 mt-3">Current Loan Details</h6>
            <div className="row d-flex gap-1">
              <div className="col">
                <label htmlFor="loanrefno">
                  <p>
                    Loan Reference No. <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={indivloandata[0]?.loan_reference_number}
                />

              </div>

              <form className="col m-2 mt-0" >
                <label htmlFor="loantype">
                  <p>Loan Type</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={indivloandata[0]?.loan_type_name}
                />
              </form>

              <form className="col-md m-2 mt-0">
                <label htmlFor="loanamount">
                  <p>Loan Amount</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={(indivloandata[0]?.admin_request_loan_currency ===
                    LOAN_CURRENCY_TYPE_BHD
                    ? LOAN_CURRENCY_TYPE_BHD + " "
                    : "$\u00A0") + formattedNumber}
                />
              </form>

              <form className="col-md-1 m-2 mt-0">
                <label htmlFor="tenure">
                  <p>Tenure</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={`${indivloandata[0]?.admin_request_loan_tenure
                    != undefined
                    ? indivloandata[0]?.admin_request_loan_tenure
                    +
                    (indivloandata[0]?.admin_request_loan_tenure
                      == 1
                      ? " Month"
                      : " Months")
                    : ""
                    }`}
                />
              </form>

              <form className="col m-2 mt-0">
                <label htmlFor="loanpurpose">
                  <p>Loan Purpose</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={indivloandata[0]?.loan_purpose}
                />
              </form>

              <form className="col m-2 mt-0">
                <label htmlFor="monthlyprofitrate">
                  <p>Monthly Rate</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={
                    indivloandata[0]?.bennefin_roi === undefined
                      ? "" : indivloandata[0]?.bennefin_roi + "%"

                  }
                />
              </form>
            </div>
          </div>

          <div className="row">
            <h3 className="mb-0 mt2">Requested Tenure Extension</h3>

            <div className="col-lg-9">
              <div className="row gap-3">
                <div className="col-lg-2">
                  <label htmlFor="amountpayable">
                    <p>Amount Payable</p>
                  </label>
                  <input
                    disabled
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder={(indivloandata[0]?.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                      ? LOAN_CURRENCY_TYPE_BHD + " "
                      : "$\u00A0") + indivloandata[0]?.amount_payable}
                  />
                </div>
                <div className="col-lg-2">
                  <label htmlFor="amountpayable">
                    <p>Actual Tenure Date</p>
                  </label>
                  <input
                    disabled
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder=
                    {indivloandata[0] != null ? moment(indivloandata[0]?.my_payment_schedules[indivloandata[0].my_payment_schedules.length - 1].tenure_date
                    ).format('DD MMM YYYY') : ''}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="date">
                    <p>
                      Extended Tenure in months <span style={{ color: "red" }}>*</span>
                    </p>
                  </label>
                  <select

                    id="date"
                    name="date"
                    className="form-select  APNL_option_flds shadow-ben"
                    aria-label="form-select example"
                    onChange={handleChangeInput}
                  >
                    <option>Select</option>
                    {months.map((mnths, index) => {
                      return (
                        <option key={index}>
                          {`${mnths}  ${mnths == 1 ? " Month" : " Months"}`}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div>
                <h6 className="mt-2">Reason for Extension</h6>
                <Form>
                  <Form.Group className=" " controlId="floatingTextarea">
                    <Form.Control
                      size="sm"
                      className="ANLtextarea "
                      name="textarea"
                      as="textarea"
                      style={{ height: "50px", width: "95%" }}
                      rows={2}
                      placeholder="Please mention the reason for extending your tenture date."
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                </Form>
              </div>
            </div>

            <div className="col p-3 bg-light rounded-3">
              <h3 style={{ marginLeft: "16px" }}>Break-up of Total Loan</h3>
              <ul>
                <li>
                  Principal Amount
                  <br />
                  <p>{(indivloandata[0]?.admin_request_loan_currency ===
                    LOAN_CURRENCY_TYPE_BHD
                    ? LOAN_CURRENCY_TYPE_BHD + " "
                    : "$\u00A0") + indivloandata[0]?.loan_amount}</p>
                </li>
                <li className="mt-2">
                  Tenure Period and Amount <br />
                  <p>{`${indivloandata[0]?.admin_request_loan_tenure
                    !== undefined
                    ? indivloandata[0]?.admin_request_loan_tenure
                    +
                    (indivloandata[0]?.admin_request_loan_tenure
                      == 1
                      ? " Month  "
                      : " Months  ")
                    : ""
                    } ` + ("-  ") + (indivloandata[0]?.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                      ? LOAN_CURRENCY_TYPE_BHD + " "
                      : "$\u00A0") + (indivloandata[0]?.total_repaid)} </p>
                </li>
              </ul>
            </div>

            <div>
              <h6>
                Upload Documents{" "}
                <span className="gray-text fw-bolder">(Optional)</span><span style={{ color: "red" }}> ( File size should be less than 5MB *)</span>
              </h6>
              <p>
                Please upload any documents relevant to this loan, including any
                invoices, checks, or other documents.
              </p>
              <div className="upload_cls col ">
                {download.map((item) => {
                  return (
                    <div key={item.doc_type} className="row ">
                      <div className="col-lg-3 text-start  text-wrap">
                        <article>{item.doc_type}</article>
                      </div>
                      <div className="col-lg-2">
                        <label className="d-flex">
                          <img
                            src="./images/icons/plus_symbol.svg"
                            alt="UploadFile"
                          />
                          <span className="me-3 text-start">
                            {" "}
                            {!item.is_upload ? "Upload File" : " Uploaded"}
                          </span>
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) => handleChange(e, item)}
                          />
                        </label>
                      </div>

                      <div className="col-lg-5 ">
                        {item.is_upload ? (
                          <div>
                            <span>
                            <a
                              style={{ display: "table-cell", cursor: "pointer" }}
                            >
                                <i
                                  className="fa-solid fa-eye text-primary fa-eye-font"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Click to view image"
                                  onClick={(e) => handleChangeDownload(e, item)}
                                />
                              </a>{" "}
                              <span className="input_filname">
                                {" "}
                                {item.file_name}
                              </span>
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className=" col-lg-6 mt-3"></div>
              </div>
            </div>
          </div>
        </div>


      </Modal.Body>

      <ModalFooter handleClose={handleClose} handleSubmit={handleSubmit} />
    </Modal>
  );
};

export default ExtendTenureDate;
